export interface DailyVerse {
  text: string;
  reference: string;
  translation: string;
}

export const dailyVerses: DailyVerse[] = [
  {
    text: "여호와는 나의 목자시니 내가 부족함이 없으리로다",
    reference: "시편 23:1",
    translation: "개역개정"
  },
  {
    text: "내가 네게 명령한 것이 아니냐 강하고 담대하라 두려워하지 말며 놀라지 말라 네가 어디로 가든지 네 하나님 여호와가 너와 함께 하느니라",
    reference: "여호수아 1:9",
    translation: "개역개정"
  },
  {
    text: "너희가 내 안에 거하고 내 말이 너희 안에 거하면 무엇이든지 원하는 대로 구하라 그리하면 이루리라",
    reference: "요한복음 15:7",
    translation: "개역개정"
  },
  {
    text: "모든 일에 감사하라 이것이 그리스도 예수 안에서 너희를 향하신 하나님의 뜻이니라",
    reference: "데살로니가전서 5:18",
    translation: "개역개정"
  },
  {
    text: "내가 주의 말씀을 내 발의 등불과 내 길의 빛으로 삼았나이다",
    reference: "시편 119:105",
    translation: "개역개정"
  }
]; 